// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"67efb250","453":"50876bb1","455":"55216ed9"}[chunkId] + ".chunk.js";
};